<script>
import mixin from "@/pages/inspection_reports/form-sections/mixin";
import Input from "@/pages/components/form/input-only/input.vue";
import MultipleRadios from "@/pages/components/form/input-only/multiple-radios.vue";

export default {
  mixins: [mixin],
  components: { Input, MultipleRadios },
  mounted() {
    this.getPairs();
    this.recalculateStates();
  },
  methods: {
    handleInput(config, value, origin) {
      this.updateCalculateState(config);

      this.$emit('update:form', {
        group: this.group.name,
        input: config[origin].name,
        value: config[origin].value,
      });
    },

    getPairs() {
      let pairs = {};
      for (let key in this.group.values) {
        let matches = [...key.match(/(remmentest_\d*_dan)_(.*)/)];
        if (!pairs[matches[1]]) {
          pairs[matches[1]] = {};
        }
        pairs[matches[1]][matches[2]] = this.group.values[key];
        pairs[matches[1]][matches[2]].name = key;
      }
      return pairs;
    },

    recalculateStates() {
      let pairs = this.getPairs();
      for (let name in pairs) {
        this.updateCalculateState(pairs[name]);
      }
    },

    updateCalculateState(config) {
      let leftValue = config['left'].value;
      let rightValue = config['right'].value;
      let isWithinMargin = config['left'].callback(config['left'].testValue, leftValue, rightValue);

      config['left'].valid = isWithinMargin ? 'OK' : 'Fout';
    }
  }
};
</script>

<template>
  <div class="col-12">
    <Card class="h-100">
      <h2 class="card-title mb-3">{{ group.title }}</h2>


      <div class="form-group row">
        <div class="col-2 d-none d-md-block">Belasting (daN)</div>
        <div class="col-6 col-md-4">Aanwijzing Links (daN)</div>
        <div class="col-6 col-md-4">Aanwijzing Rechts (daN)</div>
      </div>

      <template v-if="group.values" v-for="(config, name, index) in this.getPairs()" :key="name">
        <div class="form-group mb-2 row">
          <div class="col-12 col-md-2">
            <label class="form-label">{{ config['left'].label }}</label>
          </div>

          <div class="col-6 col-md-4">
            <Input
                id="inputLeft"
                v-bind="$attrs"
                :name="config['left'].name"
                v-model="config['left'].value"
                @update:modelValue="handleInput(config, $event, 'left')"
                required
            />
          </div>

          <div class="col-6 col-md-4">
            <Input
                id="inputRight"
                v-bind="$attrs"
                :name="config['right'].name"
                v-model="config['right'].value"
                @update:modelValue="handleInput(config, $event, 'right')"
                required
            />
          </div>

          <div class="col-12 col-md-2 mt-2 mt-md-0 d-flex justify-content-end">
            <MultipleRadios
                v-bind="$attrs"
                :name="name"
                :model-value="config['left'].valid ?? 'Fout'"
                :disabled="true"
                :options="[
                  { label: 'OK', value: 'OK' },
                  { label: 'Fout', value: 'Fout' },
                ]"
            />
          </div>
        </div>
      </template>

    </Card>
  </div>
</template>